import { createContext, useContext, useMemo, useState } from "react";

const TariffSearchContext = createContext(null);

export function TariffSearchProvider({ children }) {
  const [searchData, setSearchData] = useState("");
  const [filterType, setFilterType] = useState("");
  const [filterData, setFilterData] = useState([]);
  const [closeInputModal, setCloseInputModal] = useState(false);
  const [packageRateInputModal,setPackageRateInputModal] = useState(false); // it is use to control package rate input modal hide and show
  const [corpPagination, setCorpPagination] = useState({ page: 0, rowsPerPage: 7 });
  const [packagesPagination, setPackagesPagination] = useState({ page: 0, rowsPerPage: 7 });
  const [ratesPagination, setRatesPagination] = useState({ page: 0, rowsPerPage: 7 });
  const [packageRateCreated,setPackageRateCreated] = useState(false);
  const [openPackageFlow, setOpenPackageFlow] = useState(false); // trigger create package modal
  const [bulkEditMode, setBulkEditMode] = useState(false); // bulk edit mode toggle for packages
  const [selectedPackages, setSelectedPackages] = useState([]); // selected packages for bulk edit
  const [corpBulkEditMode, setCorpBulkEditMode] = useState(false); // bulk edit mode toggle for corporate clients
  const [selectedCorpClients, setSelectedCorpClients] = useState([]); // selected corp clients for bulk edit

  const value = useMemo(
    () => ({
      searchData,
      setSearchData,
      filterType,
      setFilterType,
      filterData,
      setFilterData,
      closeInputModal,
      setCloseInputModal,
      packageRateInputModal,
      setPackageRateInputModal,
      corpPagination,
      setCorpPagination,
      packagesPagination,
      setPackagesPagination,
      packageRateCreated,
      setPackageRateCreated,
      openPackageFlow,
      setOpenPackageFlow,
      bulkEditMode,
      setBulkEditMode,
      selectedPackages,
      setSelectedPackages,
      corpBulkEditMode,
      setCorpBulkEditMode,
      selectedCorpClients,
      setSelectedCorpClients,
      ratesPagination,
      setRatesPagination
    }),
    [searchData, filterType, filterData,closeInputModal,packageRateInputModal,corpPagination,packagesPagination,packageRateCreated,openPackageFlow,bulkEditMode,selectedPackages,corpBulkEditMode,selectedCorpClients,ratesPagination]
  );

  return (
    <TariffSearchContext.Provider value={value}>
      {children}
    </TariffSearchContext.Provider>
  );
}

export function useTariffSearch() {
  const context = useContext(TariffSearchContext);
//   if (!context) {
//     throw new Error("useTariffSearch must be used within TariffSearchProvider");
//   }
  return context;
}
